export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
            <path d="M22.1152 2.75L1.7832 11.0488L4.68777 33.4554L10.082 31.5882V50.6753L22.1152 19.9699L13.8164 23.7044L22.1152 2.75Z" fill="#FFBD3C" />
            <path
                d="M51.7823 18.725L38.2969 13.3308L29.5832 24.3267L33.3176 27.4387L26.2637 34.4926L44.106 27.4387L38.2969 24.3267L51.7823 18.725Z"
                fill="#FFBD3C"
            />
        </svg>
    );
}
